export const EXCLUDE_HTTP_STATUS = [500, 502, 504, 403, 401, 304]

export const excludeMessages = [
  'Script error.',
  // virtual 第三方报错
  'IndexSizeError: The index is not in the allowed range.',
  "evaluating 'this.cData.timeSection=360",
  "evaluating 'this.props.match.startsAt')",
  'evaluating \'n.find(".vsm-main-subtitle-season-tag"',
  "evaluating 'this.refs[s[r]].lock",
  'SRjQuery(this.props.headerContainer',
  'MediaPlaybackHandler.onMediaElementFound',
  // facebook
  "Cannot read property 'loadEventEnd' of undefined",
  // This is a bug in the Bing Instant Search feature in Edge on iOS; the feature tries to call a function that no longer exists. Thanks for the bug. https://stackoverflow.com/questions/69261499/what-is-instantsearchsdkjsbridgeclearhighlight
  'instantSearchSDKJSBridgeClearHighlight',
  "Identifier 'isMainframe'",
  '$$.blocktoggle is not a function',
  'ResizeObserver loop',
  "Failed to read the 'responseText",
  // TypeError: undefined is not an object (evaluating 'document.getElementsByTagName('video')[0].childNodes')
  "document.getElementsByTagName('video')",
  'dltNativeWebview',
  'Blocked a frame with origin "https://www.msport.com',
  'mutation.addedNodes',
  '[native code]',
  'translate_http',
  'Not Login',
  'pending cancel',
  'Background Sync is disabled',
  'https://goo.gl/LdLk22',
  'Loading chunk',
  'Loading CSS chunk',
  'Your request has timed out',
  'window.webkit.messageHandlers',
  'document.documentElement.remove',
  'database',
  'Database',
  "undefined (reading 'setMaxSize')",
  'anonymous',
  'Navigation cancelled',
  '<!DOCTYPE html>',
  'Player Not playing stream',
  'Failed to start the audio device',
  'audioVolumeChange',
  'fireChangeEvent',
  'setDefaultPosition',
  'setCurrentPosition',
  'setScreenSize',
  'fireReadyEvent',
  'fireEvent',
  'setIsViewable',
  'The operation was aborted',
  'Chartboost',
  'al_onPoststitialDismiss',
  "reading '_s'",
  // https://sabetech.sentry.io/issues/30206312/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D%20assigned%3Anone&referrer=issue-stream&sort=user&stream_index=5
  'AbortError',
  // https://sabetech.sentry.io/issues/30203559/?project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=14d&stream_index=3
  'status code 403',
  'status code 422',
  'status code 429',
  'status code 500',
  'status code 502',
  'status code 504',
  'status code 507',
  'status code 510',
  // https://sabetech.sentry.io/issues/30203387/?environment=production&project=4508811475550288&query=is%3Aunresolved%20title%3A%22%2ALoad%20failed%2A%22&referrer=issue-stream&sort=user&statsPeriod=7d&stream_index=0
  'Load failed',
  'UnknownError: Internal error',
  'onPagePause',
  // WebViewJavascriptBridge is not defined: https://sabetech.sentry.io/issues/30203487/?project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=7d&stream_index=0
  'WebViewJavascriptBridge',
  // https://sabetech.sentry.io/issues/30216426/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=7d&stream_index=2
  'Network Error',
  // https://sabetech.sentry.io/issues/30298496/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=7d&stream_index=3
  'Failed to fetch',
  // https://sabetech.sentry.io/issues/30342081/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=7d&stream_index=2
  'setRemoteDescription',
  // https://sabetech.sentry.io/issues/30203192/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=24h&stream_index=17
  'this.isHorizontal is not a function',
  // https://sabetech.sentry.io/issues/30210069/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&statsPeriod=1h&stream_index=10
  'The operation is not supported',
  // https://sabetech.sentry.io/issues/30381658/?project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&stream_index=0
  '._s',
  // third: https://sabetech.sentry.io/issues/30218450/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D%20assigned%3Anone&referrer=issue-stream&sort=user&stream_index=3
  'no supported source was found',
  // https://sabetech.sentry.io/issues/30210121/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D%20assigned%3Anone&referrer=issue-stream&sort=user&stream_index=2
  'Version change transaction',
  // third: https://sabetech.sentry.io/issues/30256799/?environment=production&project=4508811475550288&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D%20assigned%3Anone&referrer=issue-stream&sort=user&stream_index=4
  'NetworkError'
]
